import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    id: 1,
    quote: "Coach Slater completely transformed my son's approach to the game. Not only is his physical conditioning better, but his basketball IQ and confidence have skyrocketed.",
    name: 'Sarah M.',
    role: 'Parent of High School Athlete'
  }, {
    id: 2,
    quote: 'The cognitive ball therapy sessions are incredible. As an athlete with ADHD, finding a program that keeps me engaged while improving my reaction time has been a game-changer.',
    name: 'Marcus T.',
    role: 'College Basketball Player'
  }, {
    id: 3,
    quote: "We use S.E.P. for our Homeschool P.E. requirement. The variety of sports and the structured, encouraging environment make it the highlight of my kids' week.",
    name: 'David L.',
    role: 'Homeschool Parent'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextTestimonial = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };
  return <section className="py-20 md:py-28 bg-white" data-id="element-226">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="text-center mb-16" data-id="element-228">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-sep-charcoal uppercase" data-id="element-229">
            WHAT ATHLETES & PARENTS SAY
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scale: 0
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="w-24 h-1.5 bg-sep-red mx-auto mt-6" data-id="element-230"></motion.div>
        </div>

        <div className="relative bg-sep-offwhite rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-231">
          <Quote className="absolute top-6 left-6 md:top-10 md:left-10 text-sep-red/10 w-16 h-16 md:w-24 md:h-24" data-id="element-232" />

          <div className="relative z-10 min-h-[250px] flex flex-col justify-center items-center text-center" data-id="element-233">
            <AnimatePresence mode="wait" data-id="element-234">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.3
            }} className="w-full max-w-3xl" data-id="element-235">
                <div className="flex justify-center mb-6" data-id="element-236">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 text-yellow-400 fill-current" data-id="element-237" />)}
                </div>

                <p className="text-xl md:text-2xl text-gray-800 font-medium italic mb-8 leading-relaxed" data-id="element-238">
                  "{testimonials[currentIndex].quote}"
                </p>

                <div data-id="element-239">
                  <h4 className="font-bold text-lg text-sep-charcoal" data-id="element-240">
                    {testimonials[currentIndex].name}
                  </h4>
                  <p className="text-sep-red font-medium" data-id="element-241">
                    {testimonials[currentIndex].role}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Controls */}
          <div className="flex justify-center items-center gap-4 mt-8" data-id="element-242">
            <button onClick={prevTestimonial} className="p-2 rounded-full bg-white shadow-md text-gray-600 hover:text-sep-red hover:bg-gray-50 transition-colors" aria-label="Previous testimonial" data-id="element-243">
              <ChevronLeft size={24} data-id="element-244" />
            </button>

            <div className="flex gap-2" data-id="element-245">
              {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-3 h-3 rounded-full transition-colors ${index === currentIndex ? 'bg-sep-red' : 'bg-gray-300'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-246" />)}
            </div>

            <button onClick={nextTestimonial} className="p-2 rounded-full bg-white shadow-md text-gray-600 hover:text-sep-red hover:bg-gray-50 transition-colors" aria-label="Next testimonial" data-id="element-247">
              <ChevronRight size={24} data-id="element-248" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}